import { useSelector } from 'react-redux';

import { IState } from '../store/reducers/metadata';
import { getMetadata } from '../store/selectors/metadata';

export function useMetadata(): IState['data'] {
  return useSelector(getMetadata);
}
